import React, { useEffect, useState } from 'react';
import { feedbackAPI } from '../../services/api';
import { fmtDate } from '../../utils/dateUtils';

export default function Feedback() {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [replyFor, setReplyFor] = useState(null);
  const [replyText, setReplyText] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const load = () =>
    feedbackAPI.list().then(({ data }) => setFeedbacks(data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const openReply = (fb) => {
    setReplyFor(fb.id);
    setReplyText(fb.reply || '');
  };

  const submitReply = async (e) => {
    e.preventDefault();
    if (!replyText.trim()) return;
    setSaving(true);
    try {
      await feedbackAPI.reply(replyFor, { reply: replyText.trim() });
      setReplyFor(null);
      setReplyText('');
      setMsg('Reply submitted successfully');
      setTimeout(() => setMsg(''), 3000);
      load();
    } finally {
      setSaving(false);
    }
  };

  const monthName = (m) => new Date(0, m - 1).toLocaleString('default', { month: 'long' });

  if (loading) return <div className="page-loading">Loading...</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h2>My Feedback</h2>
      </div>

      {msg && <div className="alert alert-success">{msg}</div>}

      {feedbacks.length === 0 ? (
        <div className="empty-state">No feedback yet.</div>
      ) : (
        <div className="feedback-list">
          {feedbacks.map((fb) => (
            <div key={fb.id} className="card mb-4">
              <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3>
                  {monthName(fb.month)} {fb.year}
                  {fb.rating && <span className="badge badge-blue ml-2">⭐ {fb.rating}/5</span>}
                </h3>
                <span className="text-muted" style={{ fontSize: 13 }}>
                  {new Date(fb.created_at + 'Z').toLocaleDateString()}
                </span>
              </div>
              <div style={{ padding: '12px 16px' }}>
                <p style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{fb.content}</p>

                {fb.reply && (
                  <div style={{ marginTop: 14, padding: 12, background: 'var(--bg-subtle, #f5f6f8)', borderRadius: 8 }}>
                    <div className="text-muted" style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>
                      Your Reply{fb.replied_at ? ` · ${fmtDate(fb.replied_at)}` : ''}
                    </div>
                    <p style={{ whiteSpace: 'pre-wrap', margin: 0, fontSize: 13.5 }}>{fb.reply}</p>
                  </div>
                )}

                {replyFor === fb.id ? (
                  <form onSubmit={submitReply} style={{ marginTop: 14 }}>
                    <textarea
                      required
                      rows={3}
                      placeholder="Write your reply..."
                      value={replyText}
                      onChange={(e) => setReplyText(e.target.value)}
                      style={{ width: '100%' }}
                    />
                    <div className="form-actions" style={{ marginTop: 8 }}>
                      <button type="button" className="btn btn-ghost" onClick={() => setReplyFor(null)} disabled={saving}>Cancel</button>
                      <button type="submit" className="btn btn-primary" disabled={saving}>
                        {saving ? 'Saving...' : 'Submit Reply'}
                      </button>
                    </div>
                  </form>
                ) : (
                  <div style={{ marginTop: 12 }}>
                    <button className="btn btn-sm btn-ghost" onClick={() => openReply(fb)}>
                      {fb.reply ? 'Edit Reply' : '+ Reply'}
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
